{
  "CapabilitiesAffected": "Funcionalidades afectadas:",
  "ShowRelated": "Mostrar {relatedCount} relacionados"
}
